import React from 'react';
import injectSheet from 'react-jss';
import cn from 'classnames';
import Button from './Button';
import theme, { buttonReset } from '../../styles/theme';
import { defaultProps, formatOptions, propTypes } from './common';

const Inline = ({
  all, classes, className, onChange, options, selected,
}) => (
  <div className={cn(className, classes.container)}>
    {formatOptions(options, all).map(({ text, value }) => (
      <Button
        key={text}
        selected={selected === value}
        text={text}
        onClick={onChange ? () => onChange(value) : undefined}
        className={classes.button}
      />
    ))}
  </div>
);

Inline.propTypes = { ...propTypes };
Inline.defaultProps = { ...defaultProps };

export default injectSheet({
  container: {
    position: 'relative',
    marginLeft: -8,
    marginRight: -8,
  },
  button: {
    [theme.breakpoints.down('sm')]: {
      ...buttonReset({
        fontSize: 13,
        padding: [8, 8, 4],
        letterSpacing: 2,
        lineHeight: 'normal',
        '&::after': {
          borderBottomWidth: 2,
        },
      }),
    },
  },
})(Inline);
